// Core modules
import { Component, OnInit } from '@angular/core';
import { AuthService } from '@core/auth.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

/**
 * Header components
 */
@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit {

  public currentLang = 'nl';

  /**
   * Life cycle method
   */
  constructor(
    public authService: AuthService,
    public router: Router,
    public translateService: TranslateService
  ) {
    this.translateService.addLangs(['en', 'nl']);
    const activeLang = this.translateService.currentLang || this.translateService.getBrowserLang() || 'nl';
    this.currentLang = activeLang.match(/en|nl/) ? activeLang : 'nl';
    this.translateService.use(this.currentLang);
  }

  /**
   * Life cycle init method
   */
  ngOnInit() {
  }

  /**
   * Switch portal language between NL and EN
   */
  switchLanguage(lang: string): void {
    this.currentLang = lang;
    this.translateService.use(lang);
  }

  /**
   * Method to logout from the system
   */
  logout(): void {
    this.authService.logout();
    this.router.navigate(['login']);
  }

}
